import { gql } from '@apollo/client';

export const LOGIN_MUATION = gql`
  mutation Login($userName: String!, $password: String!) {
    login(userName: $userName, password: $password) {
      success
      token
      refreshToken
    }
  }
`;
